'use client';
import { useCustomTheme } from '@/lib/hooks/useCustomTheme';
import React from 'react';

export default function CustomTheme() {
    const { getCustomTheme } = useCustomTheme();
    const theme = getCustomTheme()?.cssVariables ?? '';

    return (
        <>
            <style>{theme}</style>
        </>
    );
}
